<div class="multi-select" [class.multi-select--form]="appearance === 'form'">
  <div class="select-container">
    <button
      type="button"
      class="trigger"
      [class.trigger--open]="open"
      [class.trigger--error]="error"
      [class.trigger--placeholder]="selectedIds.length === 0"
      (click)="toggleOpen(); $event.stopPropagation()"
      [attr.aria-expanded]="open">
      <span class="trigger-label">{{ triggerText }}</span>
      <span class="caret" [class.caret--open]="open" aria-hidden="true">
        <svg *ngIf="appearance === 'form'" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5.28 7.38L10 12.1L14.72 7.38" stroke="#15172E" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span *ngIf="appearance !== 'form'">▾</span>
      </span>
    </button>

    <div
      *ngIf="open"
      #panelRef
      class="panel dropdown-panel"
      [ngStyle]="panelStyles"
      (mousedown)="$event.stopPropagation()">
      <div class="search-wrap" *ngIf="searchable">
        <input
          #searchInput
          type="search"
          class="search-input"
          [value]="searchQuery"
          (input)="onSearchInput($event)"
          (keydown)="onSearchKeydown($event)"
          (click)="$event.stopPropagation()"
          autocomplete="off"
          aria-label="Search options" />
      </div>

      <label class="menu-option" *ngIf="showSelectAll && filteredOptions.length > 0">
        <ng-container *ngIf="appearance === 'form'; else defaultAllCheckbox">
          <span class="option-checkbox">
            <input
              type="checkbox"
              class="option-checkbox-input"
              [checked]="allSelected"
              (change)="toggleAll()" />
            <span class="option-checkbox-box" [class.option-checkbox-box--checked]="allSelected">
              <svg *ngIf="allSelected" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 6L5 9L10 3" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </span>
          </span>
        </ng-container>
        <ng-template #defaultAllCheckbox>
          <input type="checkbox" [checked]="allSelected" (change)="toggleAll()" />
        </ng-template>
        <span class="menu-option-label">All</span>
      </label>

      <label class="menu-option" *ngFor="let option of filteredOptions">
        <ng-container *ngIf="appearance === 'form'; else defaultOptionCheckbox">
          <span class="option-checkbox">
            <input
              type="checkbox"
              class="option-checkbox-input"
              [checked]="isSelected(option.id)"
              (change)="toggleOne(option.id)" />
            <span class="option-checkbox-box" [class.option-checkbox-box--checked]="isSelected(option.id)">
              <svg *ngIf="isSelected(option.id)" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 6L5 9L10 3" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </span>
          </span>
        </ng-container>
        <ng-template #defaultOptionCheckbox>
          <input type="checkbox" [checked]="isSelected(option.id)" (change)="toggleOne(option.id)" />
        </ng-template>
        <span class="menu-option-label">{{ option.name }}</span>
      </label>

      <div class="empty-search" *ngIf="searchable && filteredOptions.length === 0">
        No matches found
      </div>
    </div>
  </div>

  <div class="tags" *ngIf="showTags && selectedOptions.length > 0">
    <div class="tags-title">{{ tagsTitle }}</div>
    <div class="tags-list">
      <button type="button" class="tag-chip" *ngFor="let option of selectedOptions" (click)="remove(option.id)">
        <span>{{ option.name }}</span>
        <span class="x">×</span>
      </button>
    </div>
  </div>
</div>
